import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {DraperBannerModule} from "@shopping-angular-components/draper-banner";
import {DraperBannerWrapperComponent} from "./draper-banner-wrapper.component";



@NgModule({
  declarations: [DraperBannerWrapperComponent],
  exports: [
    DraperBannerWrapperComponent
  ],
  imports: [
    CommonModule,
    DraperBannerModule
  ]
})
export class DraperBannerWrapperModule { }
